import React from "react";

import { useFormikContext } from "formik";
import { Delete } from "icons";

import { Button } from "clearsense-ui/components";

import { DEFAULT_CONDITION_VALUES, DEFAULT_LIMITS } from "../constants";

const Footer = ({
  arrayHelpers,
  setConditionValues,
  setLimits,
  index,
  limits,
}) => {
  const {
    setFieldValue,
    setFieldTouched,
    values: { conditionGroups },
    setFieldError,
    errors,
    isValid,
  } = useFormikContext();

  const handleSave = () => {
    if (conditionGroups[index].change > limits.max) {
      setFieldError(
        `conditionGroups.${index}.change`,
        `Change cannot be greater than ${limits.max}`
      );
    } else if (conditionGroups[index].change < limits.min) {
      setFieldError(
        `conditionGroups.${index}.change`,
        `Change cannot be less than ${limits.min}`
      );
    } else {
      setFieldTouched(`conditionGroups.${index}.change`);
      setFieldTouched(`conditionGroups.${index}.columnName`);
      setFieldTouched(`conditionGroups.${index}.columnValue`);
      isValid
        ? setFieldValue(`conditionGroups.${index}.isSaved`, true)
        : errors?.conditionGroups[index] === undefined
        ? setFieldValue(`conditionGroups.${index}.isSaved`, true)
        : setFieldValue(`conditionGroups.${index}.isSaved`, false);
    }
  };

  const handleCancel = () => {
    setFieldValue(`conditionGroups.${index}`, DEFAULT_CONDITION_VALUES);
    setConditionValues([]);
    setLimits(DEFAULT_LIMITS);
  };

  return (
    <div className="space-x-2">
      <Button label="Save Condition" onClick={() => handleSave()} />
      <Button label="Cancel" style="text" onClick={() => handleCancel()} />
      {index !== 0 && (
        <Button
          icon={Delete}
          style="danger"
          onClick={() => arrayHelpers.remove(index)}
        />
      )}
    </div>
  );
};

export default Footer;
